export const parseOptionalInt = (value: string | undefined | null) => {
  if (typeof value === 'string') {
    return parseInt(value, 10);
  }

  return undefined
}
